module.exports = __webpack_public_path__ + "static/media/financial_due_diligence3.86d1b81a.svg";